/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TaskstemplatesTaskTemplate from './TaskstemplatesTaskTemplate';

/**
 * The TasksTemplatesBody model module.
 * @module model/TasksTemplatesBody
 * @version v0.3
 */
export default class TasksTemplatesBody {
  /**
   * Constructs a new <code>TasksTemplatesBody</code>.
   * @alias module:model/TasksTemplatesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TasksTemplatesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TasksTemplatesBody} obj Optional instance to populate.
   * @return {module:model/TasksTemplatesBody} The populated <code>TasksTemplatesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TasksTemplatesBody();
      if (data.hasOwnProperty('task_template'))
        obj.taskTemplate = TaskstemplatesTaskTemplate.constructFromObject(data['task_template']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TaskstemplatesTaskTemplate} taskTemplate
 */
TasksTemplatesBody.prototype.taskTemplate = undefined;

